import { tv, type VariantProps } from "@ui/lib/tv";

export const heading = tv({
  slots: {
    root: "flex flex-col",
    bar: "flex items-center gap-5",
    title: "shrink-0",
    subtitle:
      "hidden text-lg font-normal leading-6 text-neutral-600 md:block lg:text-2xl lg:leading-8 lg:tracking-[-0.24px]",
    leftLine: "flex-1 border-t border-neutral-100",
    spacer: "flex min-w-0 flex-1 items-center gap-5",
    rightLine: "flex-1 border-t border-neutral-100",
    actions: "shrink-0",
  },
  variants: {
    color: {
      primary: { title: "text-neutral-900" },
      secondary: { title: "text-neutral-600" },
    },
    divider: {
      none: { leftLine: "hidden", rightLine: "hidden" },
      end: { leftLine: "hidden" },
      responsive: { leftLine: "hidden md:block" },
      both: {},
    },
    size: {
      sm: { title: "text-xl lg:text-2xl lg:tracking-[-0.24px]" },
      md: { title: "text-2xl lg:text-display-sm" },
      lg: {
        title: "text-2xl leading-8 tracking-[-0.24px] lg:text-display-sm lg:leading-[44px] lg:tracking-[-0.36px]",
      },
    },
    weight: {
      bold: { title: "font-bold" },
      extrabold: { title: "font-extrabold" },
    },
  },
  defaultVariants: {
    color: "secondary",
    divider: "none",
    size: "md",
    weight: "extrabold",
  },
});

export type HeadingVariants = VariantProps<typeof heading>;
export type HeadingColor = NonNullable<HeadingVariants["color"]>;
export type HeadingDivider = NonNullable<HeadingVariants["divider"]>;
export type HeadingSize = NonNullable<HeadingVariants["size"]>;
export type HeadingWeight = NonNullable<HeadingVariants["weight"]>;
